
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  name: 'RegisterIndex',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  middleware: ['redirectPage'],
  data() {
    return {
      isLoading: false,
      userSettings: {
        email: '',
        password: '',
        passwordConfirm: '',
        sprache: 'de-de',
      },
      password: '',
      passwordConfirm: '',
      apiError: null,
    }
  },
  head() {
    const i18nHEAD = this.$nuxtI18nHead({ addSeoAttributes: true })

    i18nHEAD.link = i18nHEAD.link.map((link) => {
      if (!link.href.endsWith('/')) {
        link.href = link.href + '/'
      }
      return link
    })

    return {
      title: this.$t('Account erstellen') + ' | ATHLYZER',
      htmlAttrs: {
        ...i18nHEAD.htmlAttrs,
      },
      meta: [
        {
          hid: 'og-title',
          property: 'og:title',
          content: this.$t('Account erstellen') + ' | ATHLYZER',
        },
        {
          hid: 'og-desc',
          property: 'og:description',
          content: this.$t(
            'Registriere dich jetzt und starte deine kostenlose Testphase. Starte jetzt ab 28€ p.M.',
          ),
        },
        ...i18nHEAD.meta,
      ],
      link: [...i18nHEAD.link],
    }
  },
  methods: {
    async submit(e) {
      if (!this.isLoading) {
        this.isLoading = true
        this.apiError = null
        try {
          await this.$superlogin.register({
            sprache: this.userSettings.sprache || 'de-de',
            email: this.userSettings.email.toLowerCase(),
            password: this.userSettings.password,
            confirmPassword: this.userSettings.passwordConfirm,
            settings: {
              vorname: null,
              nachname: null,
              email: this.userSettings.email,
              telefon: null,
              organisation_name: null,
              organisation_typ: null,
              sport_code: null,
              sport_name: null,
              funktion: null,
              videoanalysis_experience: null,
              acquisition_channel: null,
              tours: [],
              referrer: null,
            },
          })

          this.userSettings = {
            email: '',
            password: '',
            passwordConfirm: '',
            sprache: 'de-de',
          }

          this.$refs.registerForm.reset()

          this.$gtag.event('sign_up')

          this.$mixpanel.track('website.register')

          this.$gtag.event('conversion', {
            send_to: 'AW-10985098189/L8w8CIu7rIgYEM2XjfYo',
          })

          this.$router.push({
            path: '/register/success',
          })
        } catch (e) {
          this.apiError = e.name
          this.$sentry.captureException(e)
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
